import { render } from "./EditRolePage.vue?vue&type=template&id=34ff520b&ts=true"
import script from "./EditRolePage.vue?vue&type=script&lang=ts"
export * from "./EditRolePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__